export { default } from "./FeaturedStrains";
